<template>
  <div>
    <h4><b>Alerta Emitida:</b> {{alert.created_at | parseDate }}</h4>
    <h4><b>Distancia:</b> {{alert.data.distance}}</h4>
    <h4><b>Latitud:</b> {{alert.data.guard_coordinates[0]}}</h4>
    <h4><b>Longitud:</b> {{alert.data.guard_coordinates[1]}}</h4>
    <h4><b>Turno:</b> {{alert.turn_id}}</h4>
    <h4><b>Quién revisa: </b>{{alert.whoreviews || 'Sin revisión'}}</h4>
    <h4><b>Comentarios: </b>{{alert.comments || 'Sin comentarios'}}</h4>
  </div>
</template>
<script>
import moment from 'moment'
import 'moment/locale/es'
export default {
  props:{
    alert: Object
  },
  filters: {
    parseDate (val) {
      try {
        return moment(val).calendar()
      } catch (e) {
        console.error('error parsing date with error message ', e.message)
        return val
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/AlertItem.vue